import {createUseStyles} from "react-jss";
import {buttons} from "../../theme";

export const useStyles = createUseStyles({
    ...buttons
});